export const theme = {
  token: {},
  components: {
    Form: {
      marginLG: 8,
      marginSM: 4,
    },
    Input: {
      colorBgContainerDisabled: '#f5f5f5',
      colorTextDisabled: '#000000',
    },
    Select: {
      colorBgContainerDisabled: '#f5f5f5',
      colorTextDisabled: '#000000',
    },
    DatePicker: {
      colorBgContainerDisabled: '#f5f5f5',
      colorTextDisabled: '#000000',
    },
    Modal: {
      colorBgMask: 'rgba(0, 0, 0, 0.3)',
    },
  },
};
